// extracted by mini-css-extract-plugin
export default {"footerBlock":"Footer_footerBlock__1Kbgg","footerContainer":"Footer_footerContainer__bj9LZ"};